module.exports = __webpack_public_path__ + "/assets/img/09805c053ed9f7d4e7c0312eb7104fba.png";